import React from 'react'

import ColorPallet from '../../../utils/ColorPallet'

function ThirthSection() {
  return (
    <div className="min-h-screen text-gray-100 px-20 py-16" style={{ backgroundColor: ColorPallet.primaryLightBrown }}>
      {/* Hero Section */}
      <div className="py-12 w-auto rounded-full bg-gradient-to-r from-blue-600 to-purple-600 b-">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            KEGIATAN DI PAPAKILO HAIRSTUDIO 
          </h1>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            TRAINING CENTER
          </h1>
          <p className="text-gray-300 text-lg text-balance">
            Papakilo Training Center merupakan pusat pelatihan dan pengembangan sumber daya manusia (SDM) 
            yang meliputi kasir, kapster, office boy, receptionist dan supervisor.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 py-20">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Training Card 1 */}
          <div className="bg-white/30 backdrop-blur-sm skew-x-12 hover:skew-x-0 hover:scale-105 hover:translate-y-2 rounded-lg p-6 transition duration-300">
            <h2 className="text-2xl font-semibold mb-4" style={{ color: ColorPallet.primaryBrown }}>
              Pelatihan Tutup Uban
            </h2>
            <p className="text-gray-800 leading-relaxed">
              Pelatihan tutup Uban (Grey Cover) bertujuan agar setiap kapster dapat secara professional 
              melakukan service tutup uban (Grey Cover) dengan Teknik dan cara yang tepat dan benar. 
              Dalam pelatihan ini peserta akan dilatih mendiagnosa, membuat formula warna dan waktu 
              juga cara pengaplikasiannya yang tepat. Papakilo Training Center bekerjasama dengan ILVASTO 
              sebagai team yang melatih semua kapster di Papakilo Hairstudio.
            </p>
          </div>

          {/* Training Card 2 */}
          <div className="bg-white/30 backdrop-blur-sm -skew-x-12 hover:skew-x-0 hover:scale-105 hover:translate-y-2 rounded-lg p-6 transition duration-300">
            <h2 className="text-2xl font-semibold mb-4" style={{ color: ColorPallet.primaryBrown }}>
              Pelatihan Smoothing & Perming
            </h2>
            <p className="text-gray-800 leading-relaxed">
              Seiring perkembangan trend model rambut saat ini, Perming dan Smoothing bukan hanya 
              didominasi oleh wanita saja, bahkan saat ini pria pun juga bisa melakukan trend rambut ini. 
              Untuk itu Papakilo Hairstudio membekali setiap kapster dengan pelatihan smoothing dan 
              perming yang bekerjasama dengan L'oreal Professional sebagai team yang melatih. Dalam 
              pelatihan ini setiap kapster akan dilatih mendiagnosa keadaan rambut pelanggan, teknik 
              pengguiungan dan pelurusan yang benar, pemilihan produk yang tepat sesuai kebutuhan dan 
              kondisi rambut pelanggan dan perawatan yang harus dilakukan.
            </p>
          </div>
        </div>

        {/* Services List */}
        <div className="mt-20 bg-gray-800 rounded-lg p-6">
          <h3 className="text-xl font-semibold text-yellow-500 mb-4">
            Training Yang Sudah Berjalan
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {['Grey Cover', 'Perming', 'Smoothing', 'Anti Dandruff', 'Hair Repair'].map((service) => (
              <div key={service} className="bg-gray-700 rounded px-4 py-2 text-center hover:bg-gray-600 transition duration-300">
                {service}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThirthSection